import React from 'react';
import { connect } from 'react-redux';
import FeedbackDetailBar from '../../v2/FeedbackDetailBar';
import FeedbackDetail from '../../v2/FeedbackDetail';
import Modal from '../../Modal';
import Loading from '../../Loading';
import { connectWebsocket, setSelectedFeedback } from '../../redux/FeedbackRedux';

class SelectedFeedback extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showChat: false };
        this.toggleChat = this.toggleChat.bind(this)
    }

    componentDidMount() {
        //this.props.dispatch(connectWebsocket());
        this.props.dispatch(setSelectedFeedback(this.props.state.selected_feedback));
    }

    toggleChat() {
        this.setState({ showChat: !this.state.showChat })
    }

    render() {
        return (
            <div className="container-fluid">
                <Loading location={'page'} />
                <div
                    className={this.props.state.hide_initial_feedbacks ? "row feedbacks justify-content-center" : "row feedbacks"}>
                    {/* {!this.props.state.hide_initial_feedbacks && this.props.state.initial_feedbacks != null &&
                        <FeedbackList />
                    } */}
                    {this.props.state.feedback_detail != null &&
                        (
                            <>
                                {this.props.state.current_user && <FeedbackDetailBar isSelectedFeedback hideBackArrow={true} />}
                                <div className="mt-3 w-100"><FeedbackDetail toggleChat={this.toggleChat} showChat={this.state.showChat} feedback={this.props.state.feedback_detail} /></div>
                            </>
                        )
                    }

                    {this.props.state.initial_feedbacks == null &&
                        <div className="col-md-12 nonefound">
                            <h5 className="text-center">No {(this.props.state.status != "All" && this.props.state.status != null ? this.props.state.status : '')}
                                {__('Feedbacks Found')} {(this.props.state.query !== null ? 'with: ' + this.props.state.query : '')}</h5>
                        </div>
                    }
                </div>
                {this.props.state.feedback_detail != null &&
                    <Modal modal={this.props.state.modal} />
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(SelectedFeedback);
